import { createContext, useContext } from 'react';

export interface AuthContextType {
  user: { id: string; email?: string } | null;
  session: unknown | null;
  isAuthReady: boolean;
  signIn: (email: string, password: string) => Promise<{ error: { message: string } | null }>;
  signUp: (email: string, password: string, fullName?: string) => Promise<{ error: { message: string } | null }>;
  signOut: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

const defaultAuth: AuthContextType = {
  user: null,
  session: null,
  isAuthReady: false,
  signIn: async () => ({ error: null }),
  signUp: async () => ({ error: null }),
  signOut: async () => {},
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  return context ?? defaultAuth;
};
